<div class="mt-4">
    <div class="welcome-screen container-sm mt-5 pt-5">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div *ngIf="wrongRequestPerson && !loading" class="alert alert-info mt-2" role="alert">
                    <i class="fa fa-exclamation-circle fa-2x text-primary"></i>
                    <b>
                        {{messageErrorRequest | translate}}
                    </b>
                </div>
                <div *ngIf="wrongRequestPersonSolcert && !wrongRequestPerson && !loading"
                     class="alert alert-info mt-2"
                     role="alert">
                    <div class="row">
                        <div class="col-md-0">
                            <i class="fa fa-exclamation-circle fa-2x text-primary"></i>
                        </div>
                        <div class="col-md-10">
                            <b>
                                <div [innerHTML]="messageRequest | translate">
                                </div>
                            </b>
                        </div>
                    </div>
                    <p class="note  mt-3 text-muted"
                       *ngIf="wrongRequestPersonSolcert && !wrongRequestPerson && !loading && stateIdSolcert === 200">
                        {{"MESSAGE.REQUEST-IS-BEING-VALIDATED-WAIT" | translate}} <i class="fa fa-spinner fa-spin"
                                                                                     aria-hidden="true"></i></p>
                </div>
                <div class="card shadow-lg p-5"
                     *ngIf="!documentSigned && (!wrongRequestPerson && !wrongRequestDocument && !wrongRequestPersonSolcert1)">
                    <div>
                        <div class="text-center">
                            <h1 class="title mb-4">{{"TITLE.WELCOME"  | translate}}</h1>
                            <p class="f-500">{{signatureTypeDescription}}</p>
                            <hr>
                        </div>
                        <ol class="custom-counter">
                            <li *ngIf="hasIdentityValidation">{{"MESSAGE.REALIZE-VALIDATION-IDENTITY" | translate}}</li>
                            <li *ngIf="isCloudSignature">{{"MESSAGE.HAVE-YOUR-CELLPHONE" | translate}}
                            </li>
                            <li *ngIf="isTypeSignatureAnyThing">{{"MESSAGE.REVIEW-DOCUMENTS" | translate}}</li>
                            <li *ngIf="!isTypeSignatureAnyThing">{{"MESSAGE.REVIEW-DOCUMENTS-SIGNER" | translate}}</li>
                            <li *ngIf="isCloudSignature">{{"MESSAGE.REQUEST-OTP-CODE-TO-SIGN" | translate}}
                            </li>
                            <li *ngIf="!isTypeSignatureAnyThing">{{"MESSAGE.READY-TO-SIGN-DOCUMENT" | translate}}
                            </li>
                            <li *ngIf="isTypeSignatureAnyThing">{{"MESSAGE.READY-TO-REVIEW-DOCUMENT" | translate}}
                            </li>
                        </ol>
                        <div class="text-center mt-4">
                            <button class="btn btn-success btn-lg" (click)="StartSigning()"><i
                                    class="{{isTypeSignatureAnyThing ? 'fas fa-eye': 'fas fa-signature'}}"></i> {{"BUTTON.START" | translate}}
                                <span
                                        class="signature-type"></span>
                            </button>
                        </div>
                        <p class="note text-center mt-3 text-muted" *ngIf="!isTypeSignatureAnyThing">
                            {{"MESSAGE.REMEMBER-RUBRIC-WILL-USER-SIGNED" | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-loading *ngIf="loading"></app-loading>
